<!--
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2023-02-18 16:53:59
 * @LastEditTime: 2023-07-07 12:07:36
 * @Description: 
-->
<template>
    <div class="page">
        <Headers></Headers>
        <div class="banner">
            <div class="title_top">About System Developers</div>
            <div class="title_line"></div>

            <div class="box_div">
                <div class="mg_img">
                    <img src="@/assets/img/Mvgx1_0218.png" alt="">
                </div>
                <div class="right">
                    <div class="title">
                        <div class="h1">MetaVerse Green Exchange (MVGX)</div>
                        <div class="line"></div>
                    </div>
                    <div class="h2">Founded in 2018 and based in Singapore, MVGX is a leading digital green exchange and carbon SaaS company in Asia. MVGX has built a world-class cloud-based digital exchange with carbon footprint tag, powered by the Nasdaq trading engine and secured with rigorous compliance processes. As the first regulated exchange for the metaverse green era, MVGX has licenses from the Monetary Authority of Singapore including Recognized Market Operator license, Capital Market Service license for dealings in securities and collective investment schemes, providing custodial services, as well as Major Payment Institution license under the Payment Services Act.</div>
                </div>
            </div>

            <!-- <div class="box_div">
                <div class="mg_img">
                    <img src="@/assets/img/Acnac0218.png" alt="">
                </div>
                <div class="right">
                    <div class="title">
                        <div class="h1">Asia Carbon Neutrality Assessment Center Ltd. (ACNAC)</div>
                        <div class="line"></div>
                    </div>
                    <div class="h2">Registered in Hongkong, ACNAC is a wholly-owned subsidiary of MVGX Holdings Pte. Ltd. Singapore. ACNAC specializes in corporate carbon measurement and evaluation, including but not limited to carbon footprint measurement and carbon neutrality rating.</div>
                </div>
            </div> -->

            <div class="box_div">
                <div class="mg_img">
                    <img src="@/assets/img/tuv0218.png" alt="">
                </div>
                <div class="right">
                    <div class="title">
                        <div class="h1">TÜV SÜD</div>
                        <div class="line"></div>
                    </div>
                    <div class="h2">TÜV SÜD is your trusted partner of choice for safety, security and sustainability solutions. Over 150 years, through our offerings of testing, verification, certification and knowledge services, TÜV SÜD has added tangible value to partners and clients globally, enabling progress by managing technology-related risks and facilitating change.</div>
                </div>
            </div>
            <Bottoms/>
            <div class="flxed">14</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Bottoms from '../components/bottoms.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page15',
    components:{Headers, Bottoms},
    setup() {
        const data = reactive({})
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.mag_t{
    margin-top: 20px;
}
.margin_t{
    margin-top: 10px;
}
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
        .title_top{
            font-size: 72px;
            font-weight: 500;
            color: #013C89;
            margin: 96px 0 40px 0;
        }
        .title_line{
            width: 1252px;
            height: 2px;
            background: #013C89;
        }
        .box_div{
            width: 100%;
            margin-top: 150px;
            display: flex;
            align-items: center;
            .mg_img{
                width: 222px;
                height: 222px;
                margin-right: 48px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .right{
                width: calc(100% - 270px);
                padding-bottom: 40px;
                border-bottom: 1px solid #C5C5C6;
                .title{
                    height: 40px;
                    display: flex;
                    align-items: flex-end;
                    .h1{
                        line-height: 40px;
                        font-size: 30px;
                        font-weight: 600;
                        color: #333333;
                    }
                    .line{
                        margin-left: 10px;
                        width: 36px;
                        height: 4px;
                        background: #0DC7F5;
                    }
                }
                .h2{
                    font-size: 20px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 30px;
                    text-align: justify;
                    margin-top: 40px;
                }
            }
        }
    }
}
</style>